import { Stack, Tabs, Tab, Divider } from "@mui/material";
import "../../../../../../assets/scss/main.scss";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useState } from "react";
import { useTranslate } from "src/locales";

function FallRiskItakiFooter() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t } = useTranslate();

  return (
    <Stack
      direction={"row"}
      spacing={2}
      divider={<Divider orientation="vertical" flexItem />}
      sx={{ mt: 3 }}
    >
      <Stack>
        <Tabs
          className="ByzMuiTabs"
          sx={{
            marginBottom: 2,
          }}
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          aria-label="Tabs"
        >
          <Tab
            label={t("fall-risk-itaki.risk-level-determination-table")}
            value={0}
          />
          <Tab
            label={t("fall-risk-itaki.fall-prevention-practices")}
            value={1}
          />
          <Tab
            label={t("fall-risk-itaki.post-fall-requirements")}
            value={2}
          />
        </Tabs>

        {selectedTab === 0 ? (
          <ByzMuiTypography
            sx={{
              fontSize: 13,
              fontWeight: 400,
              whiteSpace: "pre-line",
              wordWrap: "break-word",
              margin: 0,
            }}
          >
            {t("fall-risk-itaki.risk-level")}
          </ByzMuiTypography>
        ) : selectedTab === 1 ? (
          <ByzMuiTypography
            sx={{
              fontSize: 13,
              fontWeight: 400,
              whiteSpace: "pre-line",
              wordWrap: "break-word",
              margin: 0,
              textAlign: "left",
            }}
          >
            {t("fall-risk-itaki.fall-prevention-check-list")}
          </ByzMuiTypography>
        ) : (
          <ByzMuiTypography
            sx={{
              fontSize: 13,
              fontWeight: 400,
              whiteSpace: "pre-line",
              wordWrap: "break-word",
              margin: 0,
              textAlign: "left",
            }}
          >
            {t("fall-risk-itaki.post-fall-actions")}
          </ByzMuiTypography>
        )}
      </Stack>

      <Stack direction={"column"} spacing={2}>
        <ByzMuiTypography
          sx={{
            fontSize: 13,
            fontWeight: 400,
            whiteSpace: "pre-line",
            wordWrap: "break-word",
            margin: 0,
            mt: 4,
            textAlign: "left",
          }}
        >
          {t("fall-risk-itaki.fall-prevention-notes")}
        </ByzMuiTypography>
        <ByzMuiTypography
          sx={{
            fontSize: 13,
            fontWeight: 400,
            whiteSpace: "pre-line",
            wordWrap: "break-word",
            margin: 0,
            mt: 4,
            textAlign: "left",
          }}
        >
          {t("fall-risk-itaki.patient-risk-factors")}
        </ByzMuiTypography>
      </Stack>
    </Stack>
  );
}

export default FallRiskItakiFooter;
